import type { ReactNode } from "react";
import heroCleanerAssetUrl from "@/assets/izhub-hero-cleaner.webp";
const heroCleanerAsset = { url: heroCleanerAssetUrl };

export function PageHero({ eyebrow, title, intro, children, withBackground, backgroundImage }: { eyebrow?: string; title: ReactNode; intro?: string; children?: ReactNode; withBackground?: boolean; backgroundImage?: string }) {
  return (
    <section className="relative overflow-hidden border-b border-border bg-cream/85 backdrop-blur-sm">
      {withBackground && (
        <>
          <img
            src={backgroundImage ?? heroCleanerAsset.url}
            alt=""
            aria-hidden="true"
            fetchPriority="high"
            className="pointer-events-none select-none absolute inset-y-0 right-0 h-full w-full md:w-3/4 lg:w-3/5 object-cover object-top opacity-15 md:opacity-20 [mask-image:linear-gradient(to_left,black,transparent)]"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-cream via-cream/80 to-transparent" />
        </>
      )}
      <div className="container-x relative py-16 md:py-24 max-w-4xl">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">{title}</h1>
        {intro && <p className="mt-6 text-lg text-muted-foreground max-w-2xl">{intro}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
